module.exports = __webpack_public_path__ + "img/Marketing.d5efa013.svg";